/* eslint-disable */
  
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import Authentication from '../components/Authentication';
import FeatureAdvancedVideo from '../components/FeatureAdvancedVideo';
import AdvancedBackground from '../components/FeatureComponents/AdvancedBackground';
import AdvancedStickyNav from '../components/FeatureComponents/AdvancedStickyNav';
import CarouselCard from '../components/FeatureComponents/CarouselCard';
import CodeBlock from '../components/FeatureComponents/CodeBlock';
import ExpansionPanel from '../components/FeatureComponents/ExpansionPanel';
import FullWidthRichText from '../components/FeatureComponents/FullWidthRichText';
import FullWidthRichTextForColumn from '../components/FeatureComponents/FullWidthRichTextForColumn';
import FullWidthRichTextWithSubcomponent from '../components/FeatureComponents/FullWidthRichTextWithSubcomponent';
import FullWidthTwoColTextImage from '../components/FeatureComponents/FullWidthTwoColTextImage';
import HorizontalTabs from '../components/FeatureComponents/HorizontalTabs';
import IconTeaserCard from '../components/FeatureComponents/IconTeaserCard';
import ImageAboveContentCard from '../components/FeatureComponents/ImageAboveContentCard';
import ImageAboveTextCard from '../components/FeatureComponents/ImageAboveTextCard';
import MarketoForm from '../components/FeatureComponents/MarketoForm';
import MastheadSliderContainer from '../components/FeatureComponents/MastheadSliderContainer';
import MastheadSliderElement from '../components/FeatureComponents/MastheadSliderElement';
import MastheadWithSubcomponent from '../components/FeatureComponents/MastheadWithSubcomponent';
import NewsSignupMarketoForm from '../components/FeatureComponents/NewsSignupMarketoForm';
import ResponsiveFlexGrid from '../components/FeatureComponents/ResponsiveFlexGrid';
import ResponsiveGrid from '../components/FeatureComponents/ResponsiveGrid';
import hooks from '../components/FeatureComponents/SharedUtils/hooks';
import themeColors from '../components/FeatureComponents/SharedUtils/themeColors';
import TitleVideoCard from '../components/FeatureComponents/TitleVideoCard';
import TwoColumnTextImage from '../components/FeatureComponents/TwoColumnTextImage';
import TwoColumnTextImageFullBleed from '../components/FeatureComponents/TwoColumnTextImageFullBleed';
import FilterAndSearchCommunityPostsContainer from '../components/FilterAndSearchComponents/FilterAndSearchCommunityPostsContainer';
import FilterAndSearchContainer from '../components/FilterAndSearchComponents/FilterAndSearchContainer';
import FilterAndSearchSpotlightContentVariantA from '../components/FilterAndSearchComponents/FilterAndSearchSpotlightContentVariantA';
import FilterAndSearchSpotlightContentVariantB from '../components/FilterAndSearchComponents/FilterAndSearchSpotlightContentVariantB';
import CommunityContainer from '../components/HomeComponents/CommunityContainer';
import DocumentationContainer from '../components/HomeComponents/DocumentationContainer';
import DownloadCards from '../components/HomeComponents/DownloadCards';
import DownloadsContainer from '../components/HomeComponents/DownloadsContainer';
import HelpCards from '../components/HomeComponents/HelpCards';
import HelpContainer from '../components/HomeComponents/HelpContainer';
import HomepageMasthead from '../components/HomeComponents/HomepageMasthead';
import PromotionalBanner from '../components/HomeComponents/PromotionalBanner';
import RecommendedContainer from '../components/HomeComponents/RecommendedContainer';
import StartDevelopingCards from '../components/HomeComponents/StartDevelopingCards';
import StartDevelopingContainer from '../components/HomeComponents/StartDevelopingContainer';
import TopCardsSection from '../components/HomeComponents/TopCardsSection';
import AdditionalResourcesCard from '../components/ProductComponents/AdditionalResourcesCard';
import ComponentsTabContainer from '../components/ProductComponents/ComponentsTabContainer';
import EditionsTabContainer from '../components/ProductComponents/EditionsTabContainer';
import EventBanner from '../components/ProductComponents/EventBanner';
import KeyResources from '../components/ProductComponents/KeyResources';
import ProductProgramBanner from '../components/ProductComponents/ProductProgramBanner';
import ReleaseSection from '../components/ProductComponents/ReleaseSection';
import ResourcesContainer from '../components/ProductComponents/ResourcesContainer';
import SoftwareDownloadsContainer from '../components/ProductComponents/SoftwareDownloadsContainer';
import SupportAndTrainingCardsContainer from '../components/ProductComponents/SupportAndTrainingCardsContainer';
import SupportCard from '../components/ProductComponents/SupportCard';
import SupportedDevicesContainer from '../components/ProductComponents/SupportedDevicesContainer';
import TechnicalSpecificationContainer from '../components/ProductComponents/TechnicalSpecificationContainer';
import TechnicalSpecificationContainerVariantB from '../components/ProductComponents/TechnicalSpecificationContainerVariantB';
import TechnicalSpecificationContainerVariantC from '../components/ProductComponents/TechnicalSpecificationContainerVariantC';
import ToolsAndSoftwareCard from '../components/ProductComponents/ToolsAndSoftwareCard';
import ToolsAndSoftwareCardsContainer from '../components/ProductComponents/ToolsAndSoftwareCardsContainer';
import TrainingCard from '../components/ProductComponents/TrainingCard';
import UseCaseCard from '../components/ProductComponents/UseCaseCard';
import UseCaseCardsContainer from '../components/ProductComponents/UseCaseCardsContainer';
import WorksWellWithCard from '../components/ProductComponents/WorksWellWithCard';
import WorksWellWithCardsContainer from '../components/ProductComponents/WorksWellWithCardsContainer';
import CallToActionButton from '../components/SharedComponents/CallToActionButton';
import ClientSideRedirect from '../components/SharedComponents/ClientSideRedirect';
import CommunityBlogs from '../components/SharedComponents/CommunityBlogs';
import CommunityFourm from '../components/SharedComponents/CommunityFourm';
import CommunityPostsContainer from '../components/SharedComponents/CommunityPostsContainer';
import CookieConsent from '../components/SharedComponents/CookieConsent';
import EventLink from '../components/SharedComponents/EventLink';
import EventListCard from '../components/SharedComponents/EventListCard';
import FeatureAnnouncementPanel from '../components/SharedComponents/FeatureAnnouncementPanel';
import FeatureCard from '../components/SharedComponents/FeatureCard';
import FeatureCardSmall from '../components/SharedComponents/FeatureCardSmall';
import Footer from '../components/SharedComponents/Footer';
import GlobalNavigation from '../components/SharedComponents/GlobalNavigation';
import HomeCard from '../components/SharedComponents/HomeCard';
import HomeCardsContainer from '../components/SharedComponents/HomeCardsContainer';
import HorizontalTab from '../components/SharedComponents/HorizontalTab';
import HorizontalTabsContainer from '../components/SharedComponents/HorizontalTabsContainer';
import LinkWithIconListItem from '../components/SharedComponents/LinkWithIconListItem';
import Masthead from '../components/SharedComponents/Masthead';
import MastheadBreadcrumbs from '../components/SharedComponents/MastheadBreadcrumbs';
import RichTextEditor from '../components/SharedComponents/RichTextEditor';
import SecurityCenterContainer from '../components/SharedComponents/SecurityCenterContainer';
import StarRatingMobile from '../components/SharedComponents/StarRatingMobile';
import StarsRating from '../components/SharedComponents/StarsRating';
import SupportAuth from '../components/SharedComponents/SupportAuth';
import VideoContent from '../components/SharedComponents/VideoContent';
import VirtualFAE from '../components/SharedComponents/VirtualFAE';

const components = new Map();
components.set('Authentication', Authentication);
components.set('FeatureAdvancedVideo', FeatureAdvancedVideo);
components.set('AdvancedBackground', AdvancedBackground);
components.set('AdvancedStickyNav', AdvancedStickyNav);
components.set('CarouselCard', CarouselCard);
components.set('CodeBlock', CodeBlock);
components.set('ExpansionPanel', ExpansionPanel);
components.set('FullWidthRichText', FullWidthRichText);
components.set('FullWidthRichTextForColumn', FullWidthRichTextForColumn);
components.set('FullWidthRichTextWithSubcomponent', FullWidthRichTextWithSubcomponent);
components.set('FullWidthTwoColTextImage', FullWidthTwoColTextImage);
components.set('HorizontalTabs', HorizontalTabs);
components.set('IconTeaserCard', IconTeaserCard);
components.set('ImageAboveContentCard', ImageAboveContentCard);
components.set('ImageAboveTextCard', ImageAboveTextCard);
components.set('MarketoForm', MarketoForm);
components.set('MastheadSliderContainer', MastheadSliderContainer);
components.set('MastheadSliderElement', MastheadSliderElement);
components.set('MastheadWithSubcomponent', MastheadWithSubcomponent);
components.set('NewsSignupMarketoForm', NewsSignupMarketoForm);
components.set('ResponsiveFlexGrid', ResponsiveFlexGrid);
components.set('ResponsiveGrid', ResponsiveGrid);
components.set('hooks', hooks);
components.set('themeColors', themeColors);
components.set('TitleVideoCard', TitleVideoCard);
components.set('TwoColumnTextImage', TwoColumnTextImage);
components.set('TwoColumnTextImageFullBleed', TwoColumnTextImageFullBleed);
components.set('FilterAndSearchCommunityPostsContainer', FilterAndSearchCommunityPostsContainer);
components.set('FilterAndSearchContainer', FilterAndSearchContainer);
components.set('FilterAndSearchSpotlightContentVariantA', FilterAndSearchSpotlightContentVariantA);
components.set('FilterAndSearchSpotlightContentVariantB', FilterAndSearchSpotlightContentVariantB);
components.set('CommunityContainer', CommunityContainer);
components.set('DocumentationContainer', DocumentationContainer);
components.set('DownloadCards', DownloadCards);
components.set('DownloadsContainer', DownloadsContainer);
components.set('HelpCards', HelpCards);
components.set('HelpContainer', HelpContainer);
components.set('HomepageMasthead', HomepageMasthead);
components.set('PromotionalBanner', PromotionalBanner);
components.set('RecommendedContainer', RecommendedContainer);
components.set('StartDevelopingCards', StartDevelopingCards);
components.set('StartDevelopingContainer', StartDevelopingContainer);
components.set('TopCardsSection', TopCardsSection);
components.set('AdditionalResourcesCard', AdditionalResourcesCard);
components.set('ComponentsTabContainer', ComponentsTabContainer);
components.set('EditionsTabContainer', EditionsTabContainer);
components.set('EventBanner', EventBanner);
components.set('KeyResources', KeyResources);
components.set('ProductProgramBanner', ProductProgramBanner);
components.set('ReleaseSection', ReleaseSection);
components.set('ResourcesContainer', ResourcesContainer);
components.set('SoftwareDownloadsContainer', SoftwareDownloadsContainer);
components.set('SupportAndTrainingCardsContainer', SupportAndTrainingCardsContainer);
components.set('SupportCard', SupportCard);
components.set('SupportedDevicesContainer', SupportedDevicesContainer);
components.set('TechnicalSpecificationContainer', TechnicalSpecificationContainer);
components.set('TechnicalSpecificationContainerVariantB', TechnicalSpecificationContainerVariantB);
components.set('TechnicalSpecificationContainerVariantC', TechnicalSpecificationContainerVariantC);
components.set('ToolsAndSoftwareCard', ToolsAndSoftwareCard);
components.set('ToolsAndSoftwareCardsContainer', ToolsAndSoftwareCardsContainer);
components.set('TrainingCard', TrainingCard);
components.set('UseCaseCard', UseCaseCard);
components.set('UseCaseCardsContainer', UseCaseCardsContainer);
components.set('WorksWellWithCard', WorksWellWithCard);
components.set('WorksWellWithCardsContainer', WorksWellWithCardsContainer);
components.set('CallToActionButton', CallToActionButton);
components.set('ClientSideRedirect', ClientSideRedirect);
components.set('CommunityBlogs', CommunityBlogs);
components.set('CommunityFourm', CommunityFourm);
components.set('CommunityPostsContainer', CommunityPostsContainer);
components.set('CookieConsent', CookieConsent);
components.set('EventLink', EventLink);
components.set('EventListCard', EventListCard);
components.set('FeatureAnnouncementPanel', FeatureAnnouncementPanel);
components.set('FeatureCard', FeatureCard);
components.set('FeatureCardSmall', FeatureCardSmall);
components.set('Footer', Footer);
components.set('GlobalNavigation', GlobalNavigation);
components.set('HomeCard', HomeCard);
components.set('HomeCardsContainer', HomeCardsContainer);
components.set('HorizontalTab', HorizontalTab);
components.set('HorizontalTabsContainer', HorizontalTabsContainer);
components.set('LinkWithIconListItem', LinkWithIconListItem);
components.set('Masthead', Masthead);
components.set('MastheadBreadcrumbs', MastheadBreadcrumbs);
components.set('RichTextEditor', RichTextEditor);
components.set('SecurityCenterContainer', SecurityCenterContainer);
components.set('StarRatingMobile', StarRatingMobile);
components.set('StarsRating', StarsRating);
components.set('SupportAuth', SupportAuth);
components.set('VideoContent', VideoContent);
components.set('VirtualFAE', VirtualFAE);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
